import React from "react"
import { Helmet } from "react-helmet"
import FlyerLay from "../../components/FlyerLay/FlyerLay"
import Modal from "../../components/Modal/Modal"
import logo from "../..//assets/images/ecfoundation1.png"
import arc from "../../assets/images/orgArc.png"
import tcn from "../../assets/images/orgCic.png"
import youth from "../../assets/images/orgEjyc.png"
import fresh from "../../assets/images/orgFreshStart.png"
const classes = require('./Foundation.module.scss')
const arcImg = (<img src={arc} alt="The Arc of Emerald Coast Logo" />)
const tcnImg = (<img src={tcn} alt="Children in Crisis, Inc" />)
const youthImg = (<img src={youth} alt="Eleanor J Johnson Youth Center" />)
const freshImg = (<img src={fresh} alt="Fresh Start for Children and Families" />)

// board modal is not actually included ??
const modalBoard = (
  <div className={[classes.fullRow, classes.boardRow, classes.mobile0].join(' ')}>
    <div className={[classes.box].join(' ')}>
      <div className={[classes.three, classes.col, classes.one].join(' ')}><h4><b>President</b><br/>Peggy King</h4></div>
      <div className={[classes.three, classes.col, classes.two].join(' ')}><h4><b>Vice President</b><br/>Jackie Blue</h4></div>
      <div className={[classes.three, classes.col, classes.three].join(' ')}><h4><b>Treasurer </b><br/>Nicole Nabors</h4></div>
      <div className={classes.clearfix}/><hr/><hr/><div className={classes.clearfix}/>
      
      <div className={[classes.boxBtm].join(' ')}>
        <div className={[classes.col, classes.three, classes.col1].join(' ')}>
          <p>Ashley Allegretto</p>
          <p>Charlotte Bergman</p>
          <p>Maureen Bierman</p>
          <p>Gabby Bruce</p>
          <p>Kim Cox</p>
          <p>Chris Daggs</p>
        </div>

        <div className={[classes.col, classes.three, classes.col2].join(' ')}>
          <p>Kim Denman</p>
          <p>Ron Grissom</p>
          <p>Jeremy Holcomb</p>
          <p>Tammy Magee</p>
          <p>Beth Mangum</p>
          <p>Christine McPherson</p>
        </div>

        <div className={[classes.col, classes.three, classes.col3].join(' ')}>
          <p>Sarah Peavy</p>
          <p>Shaun Ritter</p>
          <p>Stephen Smith</p>
          <p>Mary Tinsley</p>
          <p>Ginger Walker</p>
          <p>Melissa Watson</p>
        </div>
      </div>
    </div>
  </div>
)
const modalArc = (
  <div className={classes.mwrap}>
    <p>As of June 1, 2015, Horizons of Okaloosa County re-branded to The Arc of the Emerald Coast. Offering services to over 400 men, women and children with intellectual and developmental disabilities in Okaloosa, Walton and Santa Rosa Counties, our mission remains the same. "To develop a path from disability to capability".</p>
    <p>With a newly renovated, state of the art Children's Center, 3 Adult Day Training Centers, assisted living, respite care, in home early intervention, 5 group homes providing 25/7 care, job training, placement and transportation, Horizons is proud to be the largest provider of services to the disabled in the area. For those with Down Syndrome, Cerebral Palsy, Autism and other disabilities, the wants are small, but the need is large.</p>
    <p>Funds from the Emerald Coast Foundation have helped The Arc continue to provide more, and better services to better serve the community.</p>
    {arcImg}
  </div>
)
const modalYouth = (
  <div className={classes.mwrap}>
    <p>The Eleanor J Johnson Youth Center was founded in 1997 to provide youth with an equal opportunity to a safe and healthy environment, where they may receive after school tutoring and summer recreation Monday through Friday.</p>
    <p>Currently, the Youth Center is providing after school services to 76 underprivileged youth ages 6 to 15, M-F from 2pm to 6pm, with special focus placed on Math and Science. They are working hard to provide more summer programs for 2015 with hopes of many more field trips. Todd Gatlin, Executive Director, thanks all the sponsors of ECF, for helping them increase their services in 2015!</p>
    {youthImg}
  </div>
)
const modalTcn = (
  <div className={classes.mwrap}>
    <p>Children in Crisis is a local, non-profit charity committed to “Providing Homes…Keeping Brothers and Sister Together.”</p>
    <hr/>
    <p>Children in Crisis, Inc. is a 501(c)(3) non-profit organization of caring people, working together to provide homes and keep brothers and sisters together. We give a home to the abused, neglected, and abandoned children of our community.</p>
    <p>Before Children in Crisis, there was no Emergency Shelter in Circuit One (which includes Okaloosa, Walton, Escambia and Santa Rosa Counties in Northwest Florida) for young children removed from an unsafe environment on short notice. Without CIC and the stability it brings, many foster children would be moved from home to home, some as many as ten times per year.</p>
    <p> The Children's Neighborhood provides a home to an average of 100 children per year. Since opening our doors in 2008, CIC has been called “home” by over 950 children. Providing these children with almost 120,000 days and nights of a safe, loving environment to grow and thrive. At The Children's Neighborhood, sibling separation is minimized and it is our priority to keep brothers and sisters together.</p>
    <p>Our neighborhood is growing, our campus is now built up of a Emergency Shelter, five-family foster homes and Opportunity Home, with 8-studio apartments for the young adults that age out of Foster Care.  In addition we have the Clubhouse and an Administrative Offices. Your commitment to helping sustain operations of the Children's Neighborhood is vital to our success. Together, we are making a difference in the lives of hundreds of children. Thank you for supporting our children!</p>
    {tcnImg}
  </div>
)

const foundation = (props) => {
  const InnerTitle = (
    <div className={[classes.fullRow, classes.titleRow].join(' ')}>
      <div className={[classes.sectionWrap, classes.med3Def].join(' ')}>
        <div className={[classes.hlf1, classes.equal].join(' ')}><img src={logo} alt="Emerald Coast Foundation logo" /></div>
        <div className={[classes.hlf2, classes.equal].join(' ')}>
          <p className={classes.creed}>To provide support, resources, and funding to local children's charities, in order that they may achieve all their goals.</p>
        </div>
      </div>
    </div>
  )
  const FlyerContent = (
    <div className={classes.flyerContent}>
      <div className={[classes.med3Def, classes.pclass].join(' ')}>
        <p>The strength of the Emerald Coast Foundation is its ability to achieve its mission: ECF is committed to “Investing in Youth” in Northwest Florida. This capacity is encapsulated in a number of fund raising activities that take place throughout the calendar year. The largest is our annual Poker Run, held annually in August.</p>
        <p>This tremendous event, hosted by ECF, is one of the largest boat poker runs in the country. The Emerald Coast Foundation is the only not-for-profit organization that puts forth such effort, for the sole purpose of expanding its charitable reward and helping our most precious resource: the children of our community.</p>
        <p>Throughout the year we depend on local support to accomplish our calendar of events. Through sponsorships from individuals, businesses, and large corporations, the Emerald Coast Foundation is able to bring together many levels of support, and that's where you can help. By supporting ECF, you can directly help the youth organizations in Northwest Florida provide much needed services.</p>

        <div className={classes.modalLinks}>
          {/* <button type="button" data-uk-toggle="target: #boardModal" className={classes.ecLink2}>Meet Our Board Members</button> */}
          <button type="button" data-uk-toggle="target: #modalDonate" className={classes.ecLink2}>Donate</button>
        </div>
      </div>

      <div className={classes.logoList}>
        <p>Our Charities</p>
        <div className={[classes.insideXl, classes.logoFlex, classes.has4].join(' ')}>
          <button type="button" data-uk-toggle="target: #arcModal" className={[classes.lfItem, classes.arc].join(' ')}>{arcImg}</button>
          <button type="button" data-uk-toggle="target: #tcnModal" className={[classes.lfItem, classes.tcn].join(' ')}>{tcnImg}</button>
          <div className={[classes.lfItem, classes.fresh].join(' ')}>
            <a href="https://freshstartfl.com" target="_blank" rel="noreferrer">{freshImg}</a>
          </div>
          <button type="button" data-uk-toggle="target: #youthModal" className={[classes.lfItem, classes.youth].join(' ')}>{youthImg}</button>
        </div>
      </div>

      <Modal id="boardModal" modalClass="boardModal" modalTitle="Meet Our Board" modalContent={modalBoard} />
      <Modal id="arcModal" modalClass="orgmodal" modalTitle="The Arc of the Emerald Coast" modalContent={modalArc} />
      <Modal id="youthModal" modalClass="orgmodal" modalTitle="The Eleanor J Johnson Youth Center" modalContent={modalYouth} />
      <Modal id="tcnModal" modalClass="orgmodal" modalTitle="Children In Crisis, Inc" modalContent={modalTcn} />
    </div>
  )

  return (
    <div className={classes.Foundation}>
      <Helmet>
        <title>The Emerald Coast Foundation</title>
        <meta name="description" content="The Emerald Coast Foundation is an organization that supports children's charities, and youth organizations in Okaloosa County." />
      </Helmet>

      <FlyerLay where="FoundationPage" bgColor="ecTeal" InnerTitle={InnerTitle} FlyerContent={FlyerContent} ContentClass="custom" InnerWrap="custom" />
    </div>
  )
}
export default foundation